<div class="modal-content">
  <div class="modal-header" id="social-share-btns-modal-header">
        <h5 class="modal-title" title="select-exam">Viewed by:</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body">
      <div class="modal-info" id="social-share-btns-body">
        <div class="p-3">
          <div class="chat-left-aside">

            <div class="chat-left-inner inbchat-listscroll">
                <ul class="chatonline style-none ps ps--theme_default ps--active-y">
                  <ng-container *ngFor="let view of viewList; index as ind">
                    <li>
                      <a>
                          <div class="media">
                            <ng-container *ngIf="view.user_image">
                              <img src="{{view.user_image}}" alt="icon" class="img-circle"  >
                            </ng-container>
                            <ng-container *ngIf="!view.user_image && view.customProfileName">
                              <div class="img-circle profile-icon profile-name-icon"  style="background: {{view.colorPick}};">{{view.customProfileName}}</div>
                            </ng-container>
                            <ng-container *ngIf="!view.user_image && !view.customProfileName">
                              <div class="img-circle profile-icon profile-name-icon"  style="background: {{view.colorPick}};">G</div>
                            </ng-container>
                            <ng-template #customName>

                            </ng-template>

                              <div class="media-body">
                                <ng-container *ngIf="view.name">
                                  <div class="pl-2 m-0 text-body font-avbold d-flex justify-content-between align-items-center">
                                    {{view.name}}
                                </div>
                                </ng-container>
                                <ng-container *ngIf="!view.name">
                                  <div class="pl-2 m-0 text-body font-avbold d-flex justify-content-between align-items-center">
                                   Guest User
                                </div>
                                </ng-container>

                                  <div class="pl-2 text-dark small text-ellipsis">{{view.date}}</div>
                              </div>
                          </div>
                      </a>
                  </li>
                  </ng-container>
                    <li class="p-20"></li>
                </ul>
                <div *ngIf="!scrollDisable && showListLoader" class="discuss-spinner">
                  <div intersectionObserver [intersectionDebounce]="0" (visibilityChange)="onVisibilityChanged(0, $event)">
                    <mat-spinner diameter="50"></mat-spinner>
                  </div>
                </div>

                <div *ngIf="scrollDisable && viewList && viewList.length == 0">
                  <div class="no-records-found">
                      <h5>No Views yet</h5>
                  </div>
                </div>
            </div>

        </div>

        </div>
      <div class="row mt-3">
          <div class="col-12 text-right">
              <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-target="#select-subject-post" (click)="bsModalRef.hide()" data-toggle="modal">Close</button>
          </div>
      </div>

      </div>
      <!-- BODY Of POPUP ENDS -->
  </div>
</div>





